module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/2/2-2063b47a5e574b3f876e4ddfae633440.jpg";